import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileHeart, ClipboardCheck, ExternalLink, ChevronRight } from 'lucide-react';

const TeacherResourcesTab = () => {
  return (
    <div className="grid md:grid-cols-2 gap-8">
      {/* Parent Guide */}
      <div className="border-2 border-gray-200">
        <div className="p-4 border-b border-gray-200">
          <h3 className="font-bold flex items-center gap-2">
            <FileHeart size={18} className="text-green-600" />
            Multilingual Parent Guide
          </h3>
          <p className="text-sm text-gray-500 mt-1">Printable guides in 6 languages to send home with families</p>
        </div>
        <div className="p-4 space-y-3">
          {[
            { lang: "en", label: "English" },
            { lang: "es", label: "Spanish (Espanol)" },
            { lang: "zh", label: "Chinese (中文)" },
            { lang: "ar", label: "Arabic (العربية)" },
            { lang: "bn", label: "Bengali (বাংলা)" },
            { lang: "ht", label: "Haitian Creole (Kreyol)" },
          ].map(({ lang, label }) => (
            <Link key={lang} to={`/parent-guide?lang=${lang}`} className="block">
              <Button variant="outline" className="w-full btn-sharp justify-start h-11" data-testid={`parent-guide-${lang}`}>
                <FileHeart size={16} className="mr-3 text-green-600" />
                {label}
                <ChevronRight size={16} className="ml-auto text-gray-400" />
              </Button>
            </Link>
          ))}
        </div>
      </div>

      {/* Answer Keys & External Resources */}
      <div className="space-y-8">
        <div className="border-2 border-gray-200">
          <div className="p-4 border-b border-gray-200">
            <h3 className="font-bold flex items-center gap-2">
              <ClipboardCheck size={18} className="text-blue-600" />
              Answer Keys
            </h3>
            <p className="text-sm text-gray-500 mt-1">Grade-level answer keys with proficiency rubrics</p>
          </div>
          <div className="p-4">
            <Link to="/teacher-key">
              <Button className="w-full btn-sharp-primary justify-start h-12">
                <ClipboardCheck size={18} className="mr-3" />
                View All Answer Keys
                <ChevronRight size={16} className="ml-auto" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="border-2 border-gray-200">
          <div className="p-4 border-b border-gray-200">
            <h3 className="font-bold flex items-center gap-2">
              <ExternalLink size={18} className="text-indigo-600" />
              Official WIDA Resources
            </h3>
          </div>
          <div className="p-4 space-y-3">
            <a href="https://wida.wisc.edu/assess/access/practice" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-3 border border-gray-200 hover:border-[#002FA7] transition-colors">
              <span className="text-sm font-medium">WIDA Practice Items</span>
              <ExternalLink size={14} className="text-gray-400" />
            </a>
            <a href="https://wida.wisc.edu/assess/access" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-3 border border-gray-200 hover:border-[#002FA7] transition-colors">
              <span className="text-sm font-medium">About WIDA ACCESS</span>
              <ExternalLink size={14} className="text-gray-400" />
            </a>
            <a href="https://www.nysed.gov/state-assessment/wida-consortium" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-3 border border-gray-200 hover:border-[#002FA7] transition-colors">
              <span className="text-sm font-medium">NYSED WIDA Transition Info</span>
              <ExternalLink size={14} className="text-gray-400" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherResourcesTab;
